import React, { Fragment } from "react";
import classNames from "classnames";
import { motion } from "framer-motion";

const ModalWrapper = ({
  closeModal,
  children,
  className,
  disableBackdropClose,
}) => {
  // Animation variants for backdrop
  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.3,
        ease: "easeOut",
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.2,
        ease: "easeIn",
      },
    },
  };

  // Check if mobile
  const isMobile = typeof window !== "undefined" && window.innerWidth < 640;

  // Animation variants for modal content
  const modalVariants = {
    hidden: {
      opacity: isMobile ? 1 : 0,
      scale: isMobile ? 1 : 0.95,
      y: isMobile ? "100%" : 20,
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1],
      },
    },
    exit: {
      opacity: isMobile ? 1 : 0,
      scale: isMobile ? 1 : 0.95,
      y: isMobile ? "100%" : 20,
      transition: {
        duration: 0.2,
        ease: "easeIn",
      },
    },
  };

  return (
    <Fragment>
      <motion.div
        className={classNames(
          "modal-dialog",
          "fixed z-50",
          // Mobile: Full screen
          "inset-0 sm:inset-auto",
          // Desktop: Centered modal
          "sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2",
          // Width settings
          "w-full sm:w-auto sm:max-w-2xl",
          // Height settings - mobile full height, desktop is auto with max
          "h-full sm:h-auto sm:max-h-[90vh]",
          className
        )}
        variants={modalVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className="modal-content w-full h-full sm:h-auto sm:max-h-[90vh] bg-gray-900/95 backdrop-blur-xl rounded-none sm:rounded-2xl sm:border border-gray-700/50 shadow-2xl flex relative overflow-hidden">
          {/* Drag handle for mobile */}
          <div className="sm:hidden absolute top-3 left-1/2 -translate-x-1/2 z-50 pointer-events-none">
            <div className="h-1 bg-gray-600 rounded-full w-12" />
          </div>
          {children}
        </div>
      </motion.div>
      <motion.div
        onClick={!disableBackdropClose ? closeModal : undefined}
        className="modal-backdrop fixed inset-0 z-40 bg-black/60 backdrop-blur-sm"
        variants={backdropVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      />
    </Fragment>
  );
};

export default ModalWrapper;
